<template>
  <div ref="imageWrapper" class="images-wrapper">
    <img
      class="before-image"
      :src="beforeImage"
      alt="Before image"
      @load="captureWidth"
      :style="{ width: width ? `${width}px` : null }"
    />
    <div class="compare-overlay" :style="{ width: `${compareWidth}%` }">
      <img
        class="after-image"
        :src="afterImage"
        alt="After image"
        @load="captureWidth"
        :style="{ width: width ? `${width}px` : null }"
      />
    </div>
    <input class="compare__range" type="range" min="0" max="100" :step="step" v-model="compareWidth" tabindex="-1" />
    <div class="handle-wrap" :style="{ left: `${compareWidth}%` }">
      <div class="handle">
        <i class="fas fa-chevron-left"></i>
        <i class="fas fa-chevron-right"></i>
      </div>
      <span class="handle-line"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BeforeAfter',
  props: {
    value: { type: Number, default: 50 },
    beforeImage: { type: String, default: '' },
    afterImage: { type: String, default: '' },
    step: { type: Number, default: 0.1 },
  },
  data() {
    return {
      width: 0,
      compareWidth: this.value,
    }
  },
  mounted() {
    this._ro = new ResizeObserver(() => {
      this.captureWidth()
    })
    this._ro.observe(this.$refs.imageWrapper)
  },
  beforeDestroy() {
    if (this._ro) this._ro.disconnect()
  },
  methods: {
    captureWidth() {
      this.width = Math.round(this.$refs.imageWrapper.getBoundingClientRect().width)
    },
  },
}
</script>

<style scoped>
.images-wrapper {
  width: 100%;
  position: relative;
  overflow: hidden;
}
.compare-overlay {
  position: absolute;
  overflow: hidden;
  top: 0;
  left: 0;
  height: 100%;
}
.before-image {
  display: block;
  width: 100%;
  height: auto;
}
.after-image {
  display: block;
  max-width: none;
  height: auto;
}
.compare__range {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 999;
  width: 100%;
  left: 0;
  right: 0;
  height: 50px;
  cursor: ew-resize;
  background: rgba(0, 0, 0, 0.4);
  opacity: 0;
}
.handle-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  height: 100%;
  transform: translate(-50%, -50%);
  z-index: 5;
}
.handle {
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  background: #ff0000;
  border-radius: 50%;
  width: 30px;
  height: 30px;
}
.handle-line {
  content: '';
  position: absolute;
  top: 0;
  width: 4px;
  height: 100%;
  background: #ff0000;
  z-index: 4;
  pointer-events: none;
  user-select: none;
}
@media screen and (max-width: 568px) {
  .handle {
    width: 25px;
    height: 25px;
  }
  .handle__arrow {
    width: 20px;
  }
}
@media screen and (max-width: 480px) {
  .handle {
    width: 15px;
    height: 15px;
  }
  .handle__arrow {
    width: 10px;
  }
}
</style>
